export default __webpack_public_path__ + "assets/images/c03098af997d3ddccf71b2de414269bb.png";